module.exports = __webpack_public_path__ + "media/share_images/wmp-19af46d7.svg";